import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactTimeAgo from 'react-time-ago';
import LikeIcon from "../icons/Like";
import PinIcon from "../icons/Pin";
import Avatar from "../icons/Avatar";
import { Utils } from "../../utils";
import ChatsIcon from "../icons/Chats";
import Pinned from "../icons/Pinned";
import DOMPurify from "dompurify";
import EyeIcon from "../icons/Eye";
import NewBadge from "../NewBadge";

const getCleanHtml = function (details) {
    return details;
    // const decodedDetails = atob(details);
    // const decodedHtml = DOMPurify.sanitize(decodedDetails, {
    //     USE_PROFILES: { html: true },
    // });
    // const cleanHtml = decodeURIComponent(decodedHtml);
    // return cleanHtml;
}

const isPostInBudges = (postBudges, postId) => {
    if (!postId || !Array.isArray(postBudges) || postBudges.length === 0) {
        return false;
    }
    const id = String(postId);
    return postBudges.some((badgeId) => String(badgeId) === id);
};

const PostPreview = ({ community, forum, parentIndex, handlePreviewHover, isPinned = false, handleClickUserProfile, context = "community", postBudges = [] }) => {
    const navigate = useNavigate();

    let isActuallyPinned = isPinned;
    isPinned = context === "forum" ? true : isPinned;
    const media = isPinned ? (forum?.pinned_post?.media ?? "") : (forum?.latest_post?.media ?? "");
    const commentsCount = isPinned ? (forum?.pinned_post?.count_of_replies ?? 0) : (forum?.latest_post?.count_of_replies ?? 0);
    const likesCount = isPinned ? (forum?.pinned_post?.likes?.length ?? (forum?.pinned_post?.count_of_likes ?? 0)) : (forum?.latest_post?.likes?.length ?? (forum?.latest_post?.count_of_likes ?? 0));
    const postDate = isPinned ? (forum?.pinned_post?.date_of_post ?? "") : (forum?.latest_post?.date_of_post ?? "");
    const by = isPinned ? (forum?.pinned_post?.user?.username ?? "") : (forum?.latest_post?.user?.username ?? "");
    const byId = isPinned ? (forum?.pinned_post?.user?._id ?? "") : (forum?.latest_post?.user?._id ?? "");
    const postId = isPinned ? forum?.pinned_post?.post_id : forum?.latest_post?.post_id;
    const avatarMedia = isPinned ? (forum?.pinned_post?.user?.avatar ?? "") : (forum?.latest_post?.user?.avatar ?? "");
    const avatarBgColor = isPinned ? (forum?.pinned_post?.user?.name_initials_bg_color ?? "") : (forum?.latest_post?.user?.name_initials_bg_color ?? "");
    const avatarInitialsTextColor = isPinned ? (forum?.pinned_post?.user?.name_initials_text_color ?? "") : (forum?.latest_post?.user?.name_initials_text_color ?? "");
    const user = isPinned ? (forum?.pinned_post?.user ?? null) : (forum?.latest_post?.user ?? null);



    let mediaStyle = {};
    if (media.length > 0) {
        mediaStyle = {
            backgroundImage: `url('${media}')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
        };
    }

    const onMouseOver = (e) => {
        e.currentTarget.classList.add("bg-purple-100");
        e.currentTarget.classList.remove("bg-slate-50");
        handlePreviewHover(parentIndex, true);
    };

    const onMouseLeave = (e) => {
        e.currentTarget.classList.add("bg-slate-50");
        handlePreviewHover(parentIndex, false);
    };

    const threeWeeksAgo = Date.now() - 3 * 7 * 24 * 60 * 60 * 1000;
    const postTimestamp = new Date(postDate).getTime();
    const showTimeAgo = postTimestamp > threeWeeksAgo;
    const showNewBadge = isPostInBudges(postBudges, postId);

    return (
        <>
            {/* pinned post details start */}
            {isPinned &&
                <div
                    className="flex flex-col w-full max-w-[calc(100vw-0px)] md:max-w-full rounded-md p-2 xbg-slate-100 bg-white  cursor-pointer hover:bg-purple-100"
                    onClick={(e) => { e.stopPropagation(); navigate(`/community/${community._id}/forum/${forum._id}/post/${postId}`) }}
                    onMouseEnter={onMouseOver}
                    onMouseLeave={onMouseLeave}
                >
                    {/* <div className=" flex flex-row items-center">
                        <Pinned className="w-[15px] mr-1 text-sm text-red-600" />Pinned Post By :
                    </div> */}
                    <div className="text-xs mb-2 border-b border-gray-200 ">

                        {/* start of profile */}
                        <div className={`flex xbg-primary-white flex-row items-center p-1 pb-2 pl-0`}>
                            <Avatar user={user} inline={true} />
                            <div className="flex flex-row items-center ml-2 flex-grow justify-between min-w-0">
                                <div className="flex flex-row items-center w-full ">
                                    <a className="flex flex-row  items-center justify-between   hover:underline cursor-pointer">
                                        <span onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleClickUserProfile(user._id) }} className="font-bold text-black ml-1 text-md leading-[0.8]">
                                            {user.username}
                                        </span>
                                    </a>
                                    <span className="px-2">•</span>
                                    {isActuallyPinned && <>
                                        {/* <PinIcon className={'text-purple-900'} /> */}
                                        <Pinned className="w-[15px] mr-1 text-sm text-red-600" />
                                        <span className="md:hidden">Pinned Post</span>
                                        <span className="hidden md:inline">Pinned Post
                                            {context === "community" &&
                                                <> about {forum.title}</>
                                            }
                                        </span>

                                        <span className="px-2">•</span>
                                    </>}
                                    <div className="flex whitespace-normal flex-wrap">
                                        {/* {` ${Utils.formatDate(post.createdAt, "month date, year")}`} */}
                                        <ReactTimeAgo date={postDate} locale="en-US" />
                                    </div>
                                </div>
                                {/* <div className="flex flex-row items-center">
                                    <PinIcon className={'text-purple-900'} />
                                    <span className="text-xs ml-1">
                                        {user.location.city}, {user.location.state}
                                    </span>
                                </div> */}
                                <div className="hidden flex flex-row items-center">
                                    {/* <a className="flex flex-row  hover:underline cursor-pointer">
                            <ChatsIcon fillColor={'#581c88'} strokeColor={'#ffffff'} className={'w-4'} />
                            <span className="text-xs ml-1 ">
                                {Utils.comma(post.user.count_of_replies)}
                            </span>
                        </a> */}
                                    {/* <UserIcon className={'text-purple-900'} /> */}
                                    {/* <span className="text-xs ml-1"> member since: </span>
                        <span className="text-xs ml-2">
                            {Utils.formatDate(post.user.join_date.split("T")[0], "month date, year")}
                        </span> */}
                                </div>
                                {/* <div className="text-left flex flex-row text-gray-500 text-xs font-sans ">
                                    <ChatsIcon fillColor={'#581c88'} strokeColor={'#ffffff'} className={'w-4 mr-1 self-start'} />
                                    <div className="mr-1">Posted </div>
                                    <div className="flex whitespace-normal flex-wrap"> */}
                                {/* {` ${Utils.formatDate(post.createdAt, "month date, year")}`} */}
                                {/* <ReactTimeAgo date={postDate} locale="en-US" />
                                    </div>
                                </div> */}
                            </div>
                            {showNewBadge && <NewBadge />}
                        </div>
                        {/* end of profile */}
                        {/* <a
                            className="text-purple-800 text-underline pl-1 cursor-pointer"
                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleClickUserProfile(byId) }} >
                            {avatarMedia.length == 0 &&
                                <div className="flex items-center justify-center h-5 w-5 min-h-5 min-w-5 rounded-sm uppercase font-bold text-3xl font-sans"
                                    style={{ backgroundColor: avatarBgColor, color: avatarInitialsTextColor }}
                                >
                                    {by[0]}
                                </div>
                            }

                            {avatarMedia.length > 0 &&
                                <div
                                    className="inline-block h-5 w-5 min-h-5 min-w-5  rounded-sm bg-no-repeat bg-center bg-cover"
                                    style={{ backgroundImage: `url(${avatarMedia})` }}
                                ></div>
                            }

                            <span className="leading-[0.7]">{by}</span>
                        </a>
                        {showTimeAgo && <span className="px-2">•</span>}
                        <span className="text-xs ml-2x text-gray-600 pt-1 md:pt-0">
                            {showTimeAgo && <ReactTimeAgo date={postDate} locale="en-US" />}
                        </span> */}
                    </div>
                    {/* text-purple-900 */}
                    <div className="flex flex-row w-full max-w-full  md:truncate text-sm   font-bold" >
                        {isPinned ? forum?.pinned_post?.title : forum?.latest_post?.title}
                    </div>
                    <div className="line-clamp-3 w-full max-w-full  preview-post" dangerouslySetInnerHTML={{ __html: getCleanHtml(isPinned ? (forum.pinned_post?.details ?? "") : (forum.latest_post?.details ?? "")) }}></div>

                    {(media && media.length > 0) &&
                        <div className="pt-2 w-full xh-[280px] xmd:h-[384px]">
                            <img
                                className="w-full bg-center object-cover rounded-md"
                                src={media}
                                alt=""
                            />

                            {/* <div className="w-full h-full rounded-md " style={mediaStyle} ></div> */}
                        </div>
                    }


                    <div className="flex flex-row items-center justify-between pt-2 text-[#6b7280]">
                        <div className="flex flex-row items-center">
                            <LikeIcon className={'text-gray-200 md:w-3'} />
                            <span className="text-sm md:text-xs ml-1 mr-4 md:mr-2 text-gray-600">
                                {Utils.comma(likesCount)}
                            </span>
                            <ChatsIcon fillColor={'#6b7280'} strokeColor={'#ffffff'} className={'w-5 md:w-4 text-gray-500'} />
                            <span className="text-sm text-gray-600 md:text-xs ml-1 md:mr-4">
                                {Utils.comma(commentsCount)}
                            </span>
                        </div>

                    </div>
                </div>
            }
            {/* pinned post details end */}

            {isPinned == false &&
                <div
                    className="flex flex-col w-full max-w-[calc(100vw-0px)] md:max-w-full rounded-md p-2 xbg-slate-100 bg-white  cursor-pointer hover:bg-purple-100"
                    onClick={(e) => { e.stopPropagation(); navigate(`/community/${community._id}/forum/${forum._id}/post/${postId}`) }}
                    onMouseEnter={onMouseOver}
                    onMouseLeave={onMouseLeave}
                >
                    <div className="text-xs mb-2 border-b border-gray-200 ">
                        {/* <div>Latest Post By : </div> */}
                        {/* start of profile */}
                        <div className={`flex xbg-primary-white flex-row items-center p-1 pb-2 pl-0`}>

                            <Avatar user={user} inline={true} />
                            <div className="flex flex-col ml-2 flex-grow justify-between min-w-0">
                                <div className="flex flex-row items-center ">
                                    <a className="flex flex-row  items-center justify-between  hover:underline cursor-pointer">
                                        <span onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleClickUserProfile(user._id) }} className="font-bold text-black  text-md leading-[0.8]">
                                            {user.username}
                                        </span>
                                    </a>
                                    <span className="px-2">•</span>
                                    <span className="md:hidden">Latest Post</span>
                                    <span className="hidden md:inline">Latest Post
                                        {context === "community" &&
                                            <> about {forum.title}</>
                                        }
                                    </span>
                                    <span className="px-2">•</span>
                                    <div className="flex whitespace-normal flex-wrap">
                                        {/* {` ${Utils.formatDate(post.createdAt, "month date, year")}`} */}

                                        <ReactTimeAgo date={postDate} locale="en-US" />
                                    </div>
                                </div>
                                {/* <div className="flex flex-row items-center">
                                    <PinIcon className={'text-purple-900'} />
                                    <span className="text-xs ml-1">
                                        {user.location.city}, {user.location.state}
                                    </span>
                                </div> */}
                                <div className="hidden flex flex-row items-center">
                                    {/* <a className="flex flex-row  hover:underline cursor-pointer">
                            <ChatsIcon fillColor={'#581c88'} strokeColor={'#ffffff'} className={'w-4'} />
                            <span className="text-xs ml-1 ">
                                {Utils.comma(post.user.count_of_replies)}
                            </span>
                        </a> */}
                                    {/* <UserIcon className={'text-purple-900'} /> */}
                                    {/* <span className="text-xs ml-1"> member since: </span>
                        <span className="text-xs ml-2">
                            {Utils.formatDate(post.user.join_date.split("T")[0], "month date, year")}
                        </span> */}
                                </div>
                                {/* <div className="text-left flex flex-row text-gray-500 text-xs font-sans ">
                                    <ChatsIcon fillColor={'#581c88'} strokeColor={'#ffffff'} className={'w-4 mr-1 self-start'} />
                                    <div className="mr-1">Posted </div>
                                    <div className="flex whitespace-normal flex-wrap">
                                        {/* {` ${Utils.formatDate(post.createdAt, "month date, year")}`} */}
                                {/* <ReactTimeAgo date={postDate} locale="en-US" />
                                    </div>
                                </div> */}
                            </div>
                            {showNewBadge && <NewBadge />}
                        </div>
                        {/* end of profile */}
                        {/* <a
                            className=" text-purple-800 text-underline pl-1 cursor-pointer inline-flex items-end gap-x-1"
                            onClick={(e) => { e.stopPropagation(); e.preventDefault(); handleClickUserProfile(byId) }} >

                            {avatarMedia.length == 0 &&
                                <div className="flex items-center justify-center h-5 w-5 min-h-5 min-w-5 rounded-sm uppercase font-bold text-3xl font-sans"
                                    style={{ backgroundColor: avatarBgColor, color: avatarInitialsTextColor }}
                                >
                                    {by[0]}
                                </div>
                            }

                            {avatarMedia.length > 0 &&
                                <div
                                    className="inline-block h-5 w-5 min-h-5 min-w-5  rounded-sm bg-no-repeat bg-center bg-cover"
                                    style={{ backgroundImage: `url(${avatarMedia})` }}
                                ></div>
                            }

                            <span className="leading-[0.7]">{by}</span>
                        </a>
                        {showTimeAgo && <span className="px-2">•</span>}
                        <span className="text-xs ml-2x text-gray-600 pt-1 md:pt-0">
                            {showTimeAgo && <ReactTimeAgo date={postDate} locale="en-US" />}
                        </span> */}
                    </div>
                    {/* text-purple-900 */}
                    <div className="flex flex-row w-full max-w-full md:truncate text-sm  font-bold">
                        {isPinned ? forum?.pinned_post?.title : forum?.latest_post?.title}
                    </div>
                    <div className="line-clamp-3 w-full max-w-full  preview-post" dangerouslySetInnerHTML={{ __html: getCleanHtml(isPinned ? (forum.pinned_post?.details ?? "") : (forum.latest_post?.details ?? "")) }}></div>
                    {(media && media.length > 0) &&
                        <div className="pt-2 w-full  xh-[280px] xmd:h-[384px]">
                            {/* <img
                                className="inline-block   w-full max-w-full rounded-md "
                                src={media}
                                alt=""
                            /> */}

                            <img
                                className="w-full bg-center object-cover rounded-md"
                                src={media}
                                alt=""
                            />

                            {/* <div className="w-full h-full rounded-md " style={mediaStyle} ></div> */}
                        </div>
                    }
                    <div className="flex flex-row items-center justify-between pt-2 text-[#6b7280]">
                        <div className="flex flex-row items-center">
                            <LikeIcon className={'text-gray-200 md:w-3'} />
                            <span className="text-sm md:text-xs ml-1 mr-4 md:mr-2 text-gray-600">
                                {Utils.comma(likesCount)}
                            </span>
                            <ChatsIcon fillColor={'#6b7280'} strokeColor={'#ffffff'} className={'w-5 md:w-4 text-gray-500'} />
                            <span className="text-sm text-gray-600 md:text-xs ml-1 md:mr-4">
                                {Utils.comma(commentsCount)}
                            </span>
                        </div>

                        
                    </div>
                </div>
            }
        </>
    )
};

export default PostPreview;
